
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor4Off as ObiResistor4OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-4-off.js';
 
 
 

 
 export const ObiResistor4Off = createComponent({
   react: React,
   tagName: 'obi-resistor-4-off',
   elementClass: ObiResistor4OffElement,
   events: {
     
   }
  });
 
 